export const endpoint = (import.meta.env.VITE_ENV === 'dev' ? `${import.meta.env.VITE_FAKE_HOST}/graphql` : (import.meta.env.VITE_ENDPOINT ?? '')) as string;
